import React from "react";
import Frame from "../../components/frame";
import { useParams } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Countdown from "react-countdown";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import Caesium from "../../contracts/Caesium.json";
import Caesium_Cps from "../../contracts/Caesium_Cps.json";
import Web3 from "web3";
import {
  createWeb3Modal,
  defaultConfig,
  useWeb3Modal,
  useWeb3ModalAccount,
  useWeb3ModalSigner,
} from "@web3modal/ethers5/react";

const projectId = "fe5331da52e0e0ec1aeddc58e22e3e1e";
const GATEFI_ACCESS_KEY = "ZlSUJOdrMGLBjzMMdaylwXxFcPEoYaFM";
const GATEFI_Secrate_KEY = "rfsunVbWHbTLEDeNeDQugapjHhMgYeiF";
const GATEFI_BASE_URL = "https://api-sandbox.gatefi.com";
const GATEFI_Merchant_ID = "8c03b715-c156-47d5-8c6c-c41ce7b90f90";
const CryptoJS = require("crypto-js");
const randomId = function(length = 12) {
    return Math.random().toString(36).substring(2, length+2);
  };
const mainnet = {
  chainId: 1,
  name: "Ethereum",
  currency: "ETH",
  explorerUrl: "https://etherscan.io",
  rpcUrl: "https://cloudflare-eth.com",
};

const binanceSmartChain = {
  chainId: 56,
  name: "Binance Smart Chain",
  currency: "BNB",
  explorerUrl: "https://bscscan.com",
  rpcUrl: "https://rpc.ankr.com/bsc",
};

const polygon = {
  chainId: 137,
  name: "Polygon",
  currency: "MATIC",
  explorerUrl: "https://polygonscan.com",
  rpcUrl: "https://polygon-rpc.com",
};

const metadata = {
  name: "Caesium",
  description: "Caesium",
  url: "https://csm.caesiumlab.com/",
  icons: ["https://caesiumlab.com/web/assets/images/token3.png"],
};

const modal = createWeb3Modal({
  ethersConfig: defaultConfig({ metadata }),
  chains: [binanceSmartChain],
  projectId,
  themeVariables: {
    "--w3m-z-index": 999,
  },
});

const initialState = {
  loading: false,
  is_connected: false,
  web3: null,
  accounts: null,
  contract: null,
  contractAddress: null,
  contractAddress_Short: "-",
  YourAddress: "-----------",
  YourAddressfull: null,
  sponsor_address: "",
  userInfo: {},
  user_referer: "-----------",
  balance: 0,
  balanceEthVal: 0,
  amount: "",
  UsdToBnb: 0,
  referrerBonus: 0,
  current_timestamp: Math.floor(Date.now() / 1000),
  lockin_period_end_time: 90 * 24 * 3600,
  is_referrer: false,
  _TotalInvestment: 0,
  _totalUsers: 0,
  groupAIncome: 0,
  groupBIncome: 0,
  groupCIncome: 0,
  package_index: 3,
  number_of_stake: 0,
  number_of_farming: 0,
  groupEligibilityIncome: 0,
  is_flush: false,
  is_flush_one: false,
  is_flush_next: false,
  totalDepositInUSD: 0,
  flushBusinessEndDate: Date.now(),
  flushBusinessNextDate: Date.now(),
  principalToken: 0,
  token_stake_list: [],
  show_modal: false,
  one_day: 24 * 60 * 60,
  getReInvestmentAmount: 0,
  business_log_count: 0,
  business_log: null,
  min_usd_value: 50,
  sponsorList: [],
  getTotalStake: 0,
  csmTokenPrice: 0,
  token_stake_logs: [],
  availableToken: 0,
  // CPS
  contract_Cps: null,
  totalDepositInUSD_Cps: 0,
  amount_cps: 200,
  _level_Cps: 0,
  _bonus_Cps: 0,
  userCount_Cps: 0,
  userInfo_Cps: {},
  user_referer_Cps: "-----------",
  is_referrer_Cps: false,
  sponsor_address_Cps: "",
  TotalCPS_qualifier: 0,
  defualt_sponsor: "0xe639C8364384F20c244D8BB36342c617a1391614",
};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      web3: null,
      accounts: null,
      contract: null,
      contractAddress: null,
      contractAddress_Short: "-",
      YourAddress: "-----------",
      YourAddressfull: null,
      sponsor_address:
        this.props?.referral != "undefined" ? this.props?.referral : "",
      userInfo: {},
      user_referer: "-----------",
      balance: 0,
      balanceEthVal: 0,
      amount: "",
      UsdToBnb: 0,
      referrerBonus: 0,
      current_timestamp: Math.floor(Date.now() / 1000),
      lockin_period_end_time: 90 * 24 * 3600,
      is_referrer: false,
      _TotalInvestment: 0,
      _totalUsers: 0,
      groupAIncome: 0,
      groupBIncome: 0,
      groupCIncome: 0,
      package_index: 3,
      number_of_stake: 0,
      number_of_farming: 0,
      groupEligibilityIncome: 0,
      is_flush: false,
      is_flush_one: false,
      is_flush_next: false,
      totalDepositInUSD: 0,
      flushBusinessEndDate: Date.now(),
      flushBusinessNextDate: Date.now(),
      principalToken: 0,
      token_stake_list: [],
      show_modal: false,
      one_day: 24 * 60 * 60,
      getReInvestmentAmount: 0,
      business_log_count: 0,
      business_log: null,
      min_usd_value: 50,
      sponsorList: [],
      getTotalStake: 0,
      csmTokenPrice: 0,
      token_stake_logs: [],
      availableToken: 0,
      // CPS
      contract_Cps: null,
      totalDepositInUSD_Cps: 0,
      amount_cps: 200,
      _level_Cps: 0,
      _bonus_Cps: 0,
      userCount_Cps: 0,
      userInfo_Cps: {},
      user_referer_Cps: "-----------",
      is_referrer_Cps: false,
      sponsor_address_Cps:
        this.props?.referral != "undefined" ? this.props?.referral : "",
      TotalCPS_qualifier: 0,
      defualt_sponsor: "0xe639C8364384F20c244D8BB36342c617a1391614",
    };
  }

  componentDidMount = async () => {
    try {
      this.usdPriceUpdate();
      let contractAddress_Short =
        Caesium.address.slice(0, 10) +
        "....." +
        Caesium.address.slice(
          Caesium.address.length - 5,
          Caesium.address.length
        );
      this.setState({
        contractAddress_Short,
        contractAddress: Caesium.address,
      });
    } catch (error) {
      this.setState({ networkMain: false, loading: false });
      console.error(error);
    }
  };

  componentDidUpdate = async () => {
    if (this.props?.address && this.props?.address != this.state.accounts) {
      this.setState({ accounts: this.props?.address });
      this.connectToWallet();
    }

    if (this.state.accounts && !this.props?.isConnected) {
      this.disconnectFromWallet();
    }
  };

  usdPriceUpdate = async () => {
    fetch("https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDT")
      .then((response) => response.json())
      .then((data) => {
        //console.log(data);
        if (data && data.price) {
          this.setState({ UsdToBnb: data.price });
        } else {
          this.usdPriceUpdateV2();
        }
      });
  };

  usdPriceUpdateV2 = async () => {
    fetch(
      "https://api.bscscan.com/api?module=stats&action=bnbprice&apikey=Q4P6VE1CG73J2GGZA9GWM25Z4GPBJKRJ6A"
    )
      .then((response) => response.json())
      .then((data) => {
        // console.log('data v2');
        console.log(data.result.ethusd);
        if (data && data.result && data.result.ethusd) {
          let ethusd = data.result.ethusd;
          this.setState({ UsdToBnb: ethusd });
        }
      });
  };

  connectToWallet = async (e) => {
    try {
      // Get network provider and web3 instance.
      let provider = this.props?.walletProvider;
      let signer = this.props?.signer;
      let web3 = new Web3(modal);
      web3.setProvider(binanceSmartChain.rpcUrl);
      // Use web3 to get the user's accounts.
      const accounts = this.props?.address;

      const networkId = this.props?.chainId;
      if (networkId !== 56) {
        enqueueSnackbar("Error! Please connect to bsc mainnet", {
          variant: "error",
        });
        this.setState({ loading: false });
        return false;
      }

      if (this.state.accounts !== accounts) {
        // Get the contract instance.

        this.setState({ loading: true });
        const deployedNetwork = Caesium.networks;
        const instance = new web3.eth.Contract(
          Caesium.abi,
          deployedNetwork && Caesium.address,
          provider
        );

        const deployedNetwork_cps = Caesium_Cps.networks;
        const instance_cps = new web3.eth.Contract(
          Caesium_Cps.abi,
          deployedNetwork_cps && Caesium_Cps.address,
          provider
        );

        let user_account = accounts;

        this.setState({ loading: false, is_connected: true });
        this.setState(
          {
            web3,
            accounts: user_account,
            contract: instance,
            contract_Cps: instance_cps,
            contractAddress: Caesium.address,
            contractAddress_Cps: Caesium_Cps.address,
            loading: true,
          },
          this.fetchData
        );

        //this.setState({ web3, accounts:user_account, contract: instance, contractAddress:deployedNetwork.address}, this.fetchData);
        enqueueSnackbar("Wallet Connected", { variant: "success" });
      } else {
        this.setState({ loading: false, is_connected: true });
        enqueueSnackbar("Wallet Connected", { variant: "success" });
      }
    } catch (error) {
      // Catch any errors for any of the above operations.
      enqueueSnackbar(error.message, { variant: "error" });
      this.setState({ networkMain: false });
      console.error(error);
      this.setState({ loading: false });
    }
  };

  disconnectFromWallet = async () => {
    try {
      this.setState({ loading: true });
      if (this.state.web3) {
        enqueueSnackbar("Wallet disconnected", { variant: "success" });
      }
      this.setState(initialState);
    } catch (error) {
      // Catch any errors for any of the above operations.
      enqueueSnackbar(error.message, { variant: "error" });
      this.setState({ networkMain: false });
      console.error(error);
      this.setState({ loading: false });
    }
  };

  onBuy = async () => {
    try {
    let id = randomId()
      let parmas = {
        amount: "100",
        crypto: "USDT-BEP20",
        fiat: "USD",
        orderCustomId: id,
        partnerAccountId: GATEFI_Merchant_ID,
        payment: "BANKCARD",
        redirectUrl: "https://csm.caesiumlab.com/",
        region: "US",
        walletAddress: this.state.accounts,
      };

      let res = await this.doBuy(parmas);
      console.log("res", res);
      this.setState({ gateway: res });
    } catch (error) {
      console.log("overlay error", error);
    }
  };

  doBuy = async (params) => {
    let dataVerify = "GET" + `/onramp/v1/buy`;
    let res = await this.createSignature(dataVerify);
    params = new URLSearchParams(params).toString();
    console.log("res", res);
    const url = `${GATEFI_BASE_URL}/onramp/v1/buy?${params}`;
    console.log("url", url);

    const options = {
      method: "GET",
      headers: {
        signature: res,
        Accept: "application/json, application/xml, multipart/form-data",
        "api-key": GATEFI_ACCESS_KEY,
      },
    };
    console.log("url", url);
    return new Promise((resolve, reject) => {
      const result = { status: false, msg: "", data: [] };
      fetch(url, options)
        .then(function (response) {
          let json = response;
          console.log(json);
          if (json) {
            result.status = true;
            result.data = json;
            result.msg = "success";
            resolve(result);
          } else {
            if (
              json.hasOwnProperty("details") &&
              json.details.hasOwnProperty("token")
            ) {
              result.error = json.details["amount"][0];
            }
            if (json.hasOwnProperty("error")) {
              result.error = json.error;
            }
            resolve(result);
          }
        })
        .catch(function (error) {
          // handle error
          console.log("error axios", error);
          reject(error);
        })
        .finally(function () {
          // always executed
        });
    });
  };

  createSignature = (data) => {
    try {
      let hmac = CryptoJS.HmacSHA256(data, GATEFI_Secrate_KEY);
      
      return CryptoJS.enc.Hex.stringify(hmac);
    } catch (error) {
      console.log("createSignature", error);
    }
  };

  render() {
    //const { t } = this.props;
    let action_show = false;
    if (this.state.totalDepositInUSD > 0) {
      if (
        this.state.is_flush &&
        this.state.is_flush_next &&
        this.state.is_flush_one
      ) {
        action_show = true;
      } else if (
        !this.state.is_flush &&
        !this.state.is_flush_next &&
        !this.state.is_flush_one
      ) {
        action_show = false;
      } else if (
        this.state.is_flush &&
        this.state.is_flush_next &&
        !this.state.is_flush_one
      ) {
        action_show = false;
      } else if (this.state.is_flush && !this.state.is_flush_next) {
        action_show = true;
      }
    }

    let this2 = this;

    return (
      <Frame withHeader={false} withFooter={true}>
        <div className="main">
          <header id="header">
            <nav
              data-aos="zoom-out"
              data-aos-delay="800"
              className="navbar gameon-navbar navbar-expand"
            >
              <div className="container header">
                <a className="navbar-brand" href="https://caesiumlab.com">
                  <img src="assets/image/logo.png" alt="" />
                </a>
                <ul className="navbar-nav action">
                  <li className="nav-item ml-2">
                    {this.props.isConnected ? (
                      <button
                        type="button"
                        disabled={this.state.loading}
                        onClick={() => this.props.open()}
                        className="btn ml-lg-auto btn-bordered-white"
                      >
                        <i className="icon-wallet mr-md-2"></i> Wallet
                        Disconnect
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn button_animation ml-lg-auto btn-bordered-white"
                        disabled={this.state.loading}
                        onClick={() => this.props.open()}
                      >
                        <i className="icon-wallet mr-md-2"></i>Wallet Connect
                      </button>
                    )}

                    {/* {this.state.is_connected ? (
                      <button type="button" disabled={this.state.loading} onClick={()=>this.disconnectFromWallet()} className="btn ml-lg-auto btn-bordered-white">
                        <i className="icon-wallet mr-md-2"></i> Wallet Disconnect
                      </button>
                    ):(
                      <button type="button" className="btn button_animation ml-lg-auto btn-bordered-white" disabled={this.state.loading} onClick={()=>this.connectToWallet()}>
                        <i className="icon-wallet mr-md-2"></i>Wallet Connect
                      </button>
                    )} */}
                    {/* <a href="#" className="btn ml-lg-auto btn-bordered-white"><i className="icon-wallet mr-md-2"></i>Wallet Connect</a> */}
                  </li>
                  <li className="nav-item ml-2">
                    <a
                      target="_blank"
                      className="btn ml-lg-auto telegram_btn btn-bordered-white"
                      href="https://t.me/caesiumlabmedia"
                    >
                      <img src="assets/image/telegram.png" />
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
          </header>
   
            <div className="investment_box" style={{marginTop:200}}>
              <div className="investment_inner">
                <h5>
                  Referral Income
                  {/* <small>Withdrawn (0.00)</small> */}
                </h5>
                <h4>
                  $
                  {parseFloat(
                    this.state.referrerBonus * this.state.UsdToBnb
                  ).toFixed(2)}{" "}
                  <small style={{ fontSize: 12 }}>
                    ({parseFloat(this.state.referrerBonus).toFixed(4)} BNB)
                  </small>
                </h4>

                  <button
                    onClick={()=>this.onBuy()}
                    className="Withdraw_btn"
                  >
                    Withdraw <i className="icon-withdraw ml-1"></i>
                  </button>
                
              </div>
            </div>
          </div>
  
      </Frame>
    );
  }
}

function HomeHOC(props) {
  let { referral } = useParams();
  const { open, close } = useWeb3Modal();
  const { address, chainId, isConnected } = useWeb3ModalAccount();
  const { signer, walletProvider } = useWeb3ModalSigner();

  return (
    <Home
      referral={referral}
      open={open}
      address={address}
      chainId={chainId}
      isConnected={isConnected}
      signer={signer}
      walletProvider={walletProvider}
      {...props}
    />
  );
}

export default HomeHOC;
